export const origin = () => window.location.origin

export const clientConfig = { parseDate: false } as const
